import { useLocation } from "react-router-dom";
import Footer from "@/components/Footer";

/**
 * V2.7.4 — Renders the public legal Footer on every non-admin route.
 *
 * The admin backoffice (`/admin/*`) intentionally omits the public
 * footer: it has its own `AdminLayout` chrome and does not need the
 * consumer-facing legal mentions block.
 */
export default function GlobalFooter() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <Footer />;
}
